import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ToolCardProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  path?: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, icon, onClick, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (path) {
      navigate(path);
    }
  };

  return (
    <div className="tool-card" onClick={handleClick}>
      {icon && <div className="tool-card-icon">{icon}</div>}
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default ToolCard;